import React,{ useState } from 'react';
import styled from 'styled-components'
import { BsBoxArrowUpRight } from 'react-icons/bs'
import { MiniHeading, MiniSubHeading } from '../../global-styles';

export default function Project({ project , ...restProps}) {

    const [show, setShow] = useState(false);

    return(
        <Container>
            <Image src={project.img_src} alt={project.name} />
            <Details>
                <Name>
                    {project.name}
                </Name>
                <Description onClick={() => { setShow(!show) }}>
                    {
                        (show || project.description.length < 200) ?
                            project.description :
                            `${project.description.substring(0, 200)}...`
                    }
                </Description>
                <HostURL href={project.url} target={"_blank"} rel='noreferral'>
                    {/* {p.url.substr(p.url.lastIndexOf('//') + 2)} */}
                    Click Here
                    <span><BsBoxArrowUpRight /></span>
                </HostURL>
            </Details>
        </Container>
    )
}


const Container = styled.div`
    display: flex;
    box-sizing: border-box;
    margin: 0;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
    width: 30%;

    @media screen and (max-width: 1000px) {
        width: 100%;
    }
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 15px;

    @media screen and (max-width: 991px) {
        width: 560px;
        height: 100%;
    }

    @media screen and (max-width: 667px) {
        width: 300px;
        height: 300px;
    }
`;

const Details = styled.div`
    display: flex;
    flex-flow: column wrap;
    margin-top: 30px;

    @media screen and (max-width: 667px) {
        width: 100%;
    }
`;

const Name = styled(MiniHeading)`
    font-weight: 600;
    font-size: 1.5rem;

    @media screen and (max-width: 667px) {
        font-weight: 500;
        font-size: 2.4rem;
    }
`;

const Description = styled(MiniSubHeading)`
    line-height: 1.8em;
    font-size: 1rem;
    cursor: pointer;

    @media screen and (max-width: 667px) {
        line-height: 1.5em;
        font-size: 1.1rem;
    }
`;

const HostURL = styled.a`
    text-decoration: none;
    color: #eaeaea;
    display: flex;
    justify-content: center;
    align-items: space-evenly;
    width: fit-content;
    max-width: 100%;
    margin-top: 15px;
    font-size: 1.1em;
    font-weight: bolder;
    border: 2px solid #474747;
    padding: 15px 30px;
    border-radius: 30px;

    &:hover {
        background : #454545;
    }

    span{
        margin-left: 10px;
    }

    @media screen and (max-width: 667px) {
        font-weight: 400;
        font-size: 0.8rem;
        padding: 10px 20px;
    }
`;